<script>
  import { onMount } from "svelte"
  import { whenScreenTransitionFunc } from "./stores.js"
  import { targetSetId, vocabularySetId, targetWords } from "./stores.js"
  import axios from "axios"
  import Dialog from "./Dialog.svelte"

  const API_URL = process.env.API_URL
  const repetition = 5
  const exercises = [
    { answer: 1, text: "希望", kind: "1", id: "20221013175507" },
    { answer: 0, text: "不満", kind: "2", id: "20221013175521" },
    { answer: 1, text: "幸福", kind: "1", id: "20221013175507" },
    { answer: 1, text: "安心", kind: "1", id: "20221013175521" },
    { answer: 0, text: "最低", kind: "2", id: "20221013175530" },
  ]
  const maxChapter = 8
  const countDown = 3
  let baseTime = 0
  let progressTime = 0
  let chapterTime = 0
  let eachChapterTime = {}
  let wrongAnswerNum = 0
  let wordCount = 0
  let chapterNum = 0
  let subjectCount = 0
  let buttonPosition = Math.floor(Math.random() * 2)
  let test = {}
  let targetWord = {}
  let testList = []
  let resultList = []
  let targetWordList = []
  let positiveWordList = []
  let negativeWordList = []

  let kindList = [0, 1, 2]
  let shuffledTargetOrder = []
  let currentTargetIndex = 0
  let isSecondRound = false

  let shuffledPositiveOrder = []
  let shuffledNegativeOrder = []
  let currentPositiveIndex = 0
  let currentNegativeIndex = 0
  let startFlag = false
  let endFlag = false
  let showTest = false
  let showCount = false
  let isExercises = true
  let displayWarning = false
  let dialog

  onMount(async () => {
    whenScreenTransitionFunc()

    const unsubscribeTargetWords = targetWords.subscribe((words) => {
      if (words && words.length > 0) {
        targetWordList = words
      }
    })
    unsubscribeTargetWords()

    // 語彙リスト（ポジティブ・ネガティブ）を取得
    let targetSetValue
    let vocabularySetValue

    const unsubscribeTarget = targetSetId.subscribe((value) => {
      targetSetValue = value
    })

    const unsubscribeVocabulary = vocabularySetId.subscribe((value) => {
      vocabularySetValue = value
    })

    unsubscribeTarget()
    unsubscribeVocabulary()

    const apiUrl = API_URL + "/get_test"
    const params = new URLSearchParams({
      target: targetSetValue,
      vocabulary: vocabularySetValue,
    })

    const response = await axios.get(`${apiUrl}?${params.toString()}`)

    // 新しいレスポンス構造に対応
    if (response.data.target && response.data.vocabulary) {
      const vocabularyData = response.data.vocabulary.Item

      positiveWordList = (vocabularyData.positive_words || []).map(
        (word, index) => ({
          id: `positive_${index}`,
          text: word,
          answer: 1,
          kind: 1,
        })
      )

      negativeWordList = (vocabularyData.negative_words || []).map(
        (word, index) => ({
          id: `negative_${index}`,
          text: word,
          answer: 0,
          kind: 2,
        })
      )
    } else {
      testList = response.data["test"].Items
      positiveWordList = testList.filter((testList) => testList["kind"] == 1)
      negativeWordList = testList.filter((testList) => testList["kind"] == 2)
    }

    initializeShuffledTargets()
    initializeShuffledVocabulary()

    document.getElementById("start-button").style.visibility = "visible"
  })

  function initializeShuffledTargets() {
    if (targetWordList && targetWordList.length > 0) {
      shuffledTargetOrder = [...targetWordList]
      for (let i = shuffledTargetOrder.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[shuffledTargetOrder[i], shuffledTargetOrder[j]] = [
          shuffledTargetOrder[j],
          shuffledTargetOrder[i],
        ]
      }

      currentTargetIndex = 0
      setCurrentTarget()
    }
  }

  function initializeShuffledVocabulary() {
    if (positiveWordList && positiveWordList.length > 0) {
      shuffledPositiveOrder = [...positiveWordList]
      for (let i = shuffledPositiveOrder.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[shuffledPositiveOrder[i], shuffledPositiveOrder[j]] = [
          shuffledPositiveOrder[j],
          shuffledPositiveOrder[i],
        ]
      }
      currentPositiveIndex = 0
    }

    if (negativeWordList && negativeWordList.length > 0) {
      shuffledNegativeOrder = [...negativeWordList]
      for (let i = shuffledNegativeOrder.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[shuffledNegativeOrder[i], shuffledNegativeOrder[j]] = [
          shuffledNegativeOrder[j],
          shuffledNegativeOrder[i],
        ]
      }
      currentNegativeIndex = 0
    }
  }

  function setCurrentTarget() {
    if (
      shuffledTargetOrder &&
      shuffledTargetOrder.length > 0 &&
      currentTargetIndex < shuffledTargetOrder.length
    ) {
      const currentTarget = shuffledTargetOrder[currentTargetIndex]

      targetWord = {
        text: currentTarget.word,
        answer: currentTarget.type === "positive" ? 1 : 0,
        id: currentTarget.id,
        word: currentTarget.word,
        type: currentTarget.type,
        kind: 0,
      }
    }
  }

  function reshufflePositiveWords() {
    for (let i = shuffledPositiveOrder.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[shuffledPositiveOrder[i], shuffledPositiveOrder[j]] = [
        shuffledPositiveOrder[j],
        shuffledPositiveOrder[i],
      ]
    }
  }

  function reshuffleNegativeWords() {
    for (let i = shuffledNegativeOrder.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[shuffledNegativeOrder[i], shuffledNegativeOrder[j]] = [
        shuffledNegativeOrder[j],
        shuffledNegativeOrder[i],
      ]
    }
  }

  function isWordDuplicatedWithTargets(wordText) {
    if (!targetWordList || targetWordList.length === 0) {
      return false
    }

    return targetWordList.some((targetWord) => {
      const targetText = targetWord.text || targetWord.word || targetWord
      return targetText === wordText
    })
  }

  function getNextPositiveWord() {
    if (shuffledPositiveOrder && shuffledPositiveOrder.length > 0) {
      if (currentPositiveIndex >= shuffledPositiveOrder.length) {
        reshufflePositiveWords()
        currentPositiveIndex = 0
      }
      const word = shuffledPositiveOrder[currentPositiveIndex]

      if (!isWordDuplicatedWithTargets(word.text)) {
        currentPositiveIndex++
        return word
      }

      currentPositiveIndex++

      if (currentPositiveIndex >= shuffledPositiveOrder.length) {
        reshufflePositiveWords()
        currentPositiveIndex = 0
        const firstWord = shuffledPositiveOrder[0]
        currentPositiveIndex = 1
        return firstWord
      }

      return getNextPositiveWord()
    }
  }

  function getNextNegativeWord() {
    if (shuffledNegativeOrder && shuffledNegativeOrder.length > 0) {
      if (currentNegativeIndex >= shuffledNegativeOrder.length) {
        reshuffleNegativeWords()
        currentNegativeIndex = 0
      }

      const word = shuffledNegativeOrder[currentNegativeIndex]

      // ターゲット語と重複していないかチェック
      if (!isWordDuplicatedWithTargets(word.text)) {
        currentNegativeIndex++
        return word
      }

      currentNegativeIndex++

      if (currentNegativeIndex >= shuffledNegativeOrder.length) {
        reshuffleNegativeWords()
        currentNegativeIndex = 0
        const firstWord = shuffledNegativeOrder[0]
        currentNegativeIndex = 1
        return firstWord
      }

      return getNextNegativeWord()
    }
  }

  function startTest() {
    showCount = true
    document.getElementById("start-button").style.display = "none"
    document.getElementById("text").style.display = "none"
    countDownFunc()
    setExercises()
  }

  function countDownFunc() {
    progressTime = 0
    startFlag = true
    let progressID = setInterval(() => {
      if (progressTime < countDown - 1) {
        progressTime++
      } else {
        baseTime = new Date()
        showTest = true
        showCount = false
        wordCount = 0
        clearInterval(progressID)
      }
    }, 1000)
  }

  function setExercises() {
    if (exercises[0]) {
      test = exercises[0]
      exercises.shift()
    } else {
      chapterNum++
      showTest = false
      setRandomTest()
    }
  }

  function setRandomTest() {
    let kind = 0
    if (kindList.length == 0) {
      kindList = [0, 1, 2]
      wordCount++
      if (wordCount >= repetition) {
        showTest = false
        subjectCount++
        chapterNum++
        setEachChapterTime()
        currentTargetIndex++

        if (currentTargetIndex >= shuffledTargetOrder.length) {
          if (!isSecondRound) {
            isSecondRound = true
            currentTargetIndex = 0
            buttonPosition = buttonPosition == 1 ? 0 : 1
            displayWarning = true
          } else {
            endFlag = true
            postRequest()
            return
          }
        }

        setCurrentTarget()
      }
    }
    if (!kind) {
      kind = Math.floor(Math.random() * kindList.length)
    }
    if (kindList[kind] == 0) {
      test = targetWord
    } else if (kindList[kind] == 1) {
      test = getNextPositiveWord()
    } else {
      test = getNextNegativeWord()
    }
    kindList.splice(kind, 1)
  }

  function nextChapter() {
    showCount = true
    chapterTime = 0
    displayWarning = false
    countDownFunc()
  }

  async function answer(event) {
    let result = {}
    const elapsedTime = (new Date() - baseTime) / 1000
    if (test.kind == 0) {
      chapterTime += elapsedTime
    }
    result = {
      testId: test.id,
      time: elapsedTime,
      answer: event.target.value,
      text: test.text,
      kind: test.kind,
      buttonPosition: buttonPosition,
    }

    // 本番のみターゲット語情報を追加
    if (chapterNum) {
      result.target_word_id = targetWord.id
      result.target_word_text = targetWord.word
      result.target_word_type = targetWord.type
    } else {
      result.is_practice = true
    }

    if (event.target.value != test.answer) {
      wrongAnswerNum += 1
      result["correction"] = 0
    } else {
      result["correction"] = 1
    }
    resultList.push(result)
    if (chapterNum) {
      setRandomTest()
    } else {
      setExercises()
    }
    document.getElementById("question").style.visibility = "hidden"
    window.setTimeout(function () {
      if (document.getElementById("question")) {
        document.getElementById("question").style.visibility = "visible"
      }
      baseTime = new Date()
    }, 300)
  }

  function setEachChapterTime() {
    let chapterName = ""
    chapterName += targetWord.word
    chapterName +=
      targetWord.answer == 1 ? "PositiveAverageTime" : "NegativeAverageTime"
    if (!eachChapterTime[chapterName]) {
      eachChapterTime[chapterName] = 0
    }
    eachChapterTime[chapterName] += chapterTime
  }

  async function postRequest() {
    let totalTime = 0
    Object.values(eachChapterTime).forEach((value) => {
      totalTime += value
    })
    const postResult = {
      action: "set_test",
      category: "test_result",
      id: sessionStorage.getItem("id"),
      result: resultList,
      averageTime: totalTime / (maxChapter * repetition),
      totalTime: totalTime,
      wrongAnswerNum: wrongAnswerNum,
      questionnaireId: sessionStorage.getItem("questionnaireId"),
    }
    try {
      await axios.post(API_URL + "/set_result", postResult)

      // MEMO: マーケティング会社との連携のため終了後リダイレクト
      const monitorId = sessionStorage.getItem("monitor_id")
      const eqtId = sessionStorage.getItem("eqt_id")

      if (monitorId && eqtId) {
        const redirectUrl = `https://rsch.jp/common/connect_end.php?id=${monitorId}&eqtid=${eqtId}&state=8lUjzMGEMY`
        window.location.href = redirectUrl
      }
    } catch {
      dialog.showModal()
    }
  }
</script>

{#if startFlag && showTest && !chapterNum}
  <div style="opacity: 0.8;">練習中</div>
{:else if startFlag && showTest && chapterNum}
  <div style="opacity: 0.8; text-align: center;">
    <span>「{targetWord["text"]}」</span>
    が出たら
    <span>
      {#if targetWord["answer"]}○
      {:else}×
      {/if}
    </span>
    にタッチ
  </div>
{/if}
<div class="wrapper">
  {#if endFlag}
    <div class="text-area">
      <h4>
        <p>お疲れ様でした。</p>
        <p>これでテストは終了です。</p>
        <!-- <p>ブラウザを閉じてください。</p> -->
        <p>自動で画面が切り替わります。</p>
      </h4>
    </div>
  {:else if startFlag}
    {#if showTest}
      {#if test}
        <div id="question">
          {test.text}
        </div>
      {/if}
      <div
        class="answer-buttons-container"
        style="display: flex; justify-content: space-between; margin: 7vh 2em 0; "
      >
        {#if buttonPosition}
          <button on:click={answer} class="answer" value="1">
            <svg
              width="100%"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="50"
                cy="50"
                r="35"
                fill="none"
                stroke="#4d4d4d"
                stroke-width="10"
              />
            </svg>
          </button>
          <button on:click={answer} class="answer" value="0">
            <svg
              width="100%"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="20"
                y1="20"
                x2="80"
                y2="80"
                stroke="#4d4d4d"
                stroke-width="10"
              />
              <line
                x1="80"
                y1="20"
                x2="20"
                y2="80"
                stroke="#4d4d4d"
                stroke-width="10"
              />
            </svg>
          </button>
        {:else}
          <button on:click={answer} class="answer" value="0">
            <svg
              width="100%"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="20"
                y1="20"
                x2="80"
                y2="80"
                stroke="#4d4d4d"
                stroke-width="10"
              />
              <line
                x1="80"
                y1="20"
                x2="20"
                y2="80"
                stroke="#4d4d4d"
                stroke-width="10"
              />
            </svg>
          </button>
          <button on:click={answer} class="answer" value="1">
            <svg
              width="100%"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="50"
                cy="50"
                r="35"
                fill="none"
                stroke="#4d4d4d"
                stroke-width="10"
              />
            </svg>
          </button>
        {/if}
      </div>
    {:else if showCount}
      <div class="text-area" style="margin-top: 40vh">
        <p id="countdown">{countDown - progressTime}</p>
      </div>
    {:else if isExercises}
      <div class="text-area">
        <div style="margin-bottom: 4em; margin-top: 25vh">
          <p>練習問題終了です。</p>
          <p>「次へ」を押すと本番に進みます。</p>
        </div>
        <button
          class="indigo"
          style="width: 50vw; height: 3em;"
          on:click={() => {
            isExercises = false
          }}>次へ</button
        >
        <div style="margin-top: 50px; font-size: 0.9em;">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20"
            width="20"
            fill="#4d4d4d"
            style="vertical-align: sub;"
            ><path
              d="M10.021 10.458ZM2.354 17.5q-.5 0-.76-.438-.261-.437-.011-.874L9.25 2.979q.25-.437.75-.437t.75.437l7.667 13.209q.25.437-.011.874-.26.438-.76.438Zm7.667-9.146q-.354 0-.615.261-.26.26-.26.614v2.333q0 .355.26.615.261.261.615.261t.614-.261q.261-.26.261-.615V9.229q0-.354-.261-.614-.26-.261-.614-.261Zm0 6.646q.354 0 .614-.26.261-.261.261-.615t-.261-.615q-.26-.26-.614-.26t-.615.26q-.26.261-.26.615t.26.615q.261.26.615.26Zm-6.167.75h12.292L10 5.167Z"
            /></svg
          >
          <span> ブラウザの戻るボタンは使用しないでください。 </span>
        </div>
      </div>
    {:else}
      <div class="text-area" style="margin-top: 15vh">
        <p style="font-size: 1.5em">問題{chapterNum}</p>
        <div>「良いこと」が出たら〇 にタッチ</div>
        <div>「悪いこと」が出たら × にタッチ</div>
        <h4 style="margin-bottom: 4em; margin-top: 0;">
          <span style="font-size: 1.5em">「{targetWord["text"]}」</span>
          が出たら
          <span style="font-size: 2em">
            {#if targetWord["answer"]}○
            {:else}×
            {/if}
          </span>
          にタッチ
        </h4>
        {#if displayWarning}
          <div style="margin-top: -3em; margin-bottom:2em; font-size: 0.9em;">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20"
              width="20"
              fill="#4d4d4d"
              style="vertical-align: sub;"
              ><path
                d="M10.021 10.458ZM2.354 17.5q-.5 0-.76-.438-.261-.437-.011-.874L9.25 2.979q.25-.437.75-.437t.75.437l7.667 13.209q.25.437-.011.874-.26.438-.76.438Zm7.667-9.146q-.354 0-.615.261-.26.26-.26.614v2.333q0 .355.26.615.261.261.615.261t.614-.261q.261-.26.261-.615V9.229q0-.354-.261-.614-.26-.261-.614-.261Zm0 6.646q.354 0 .614-.26.261-.261.261-.615t-.261-.615q-.26-.26-.614-.26t-.615.26q-.26.261-.26.615t.26.615q.261.26.615.26Zm-6.167.75h12.292L10 5.167Z"
              /></svg
            >
            <span> ◯、× の位置が入れ替わります </span>
          </div>
        {/if}
        <button
          class="indigo"
          style="width: 50vw; height: 3em;"
          on:click={nextChapter}>次へ</button
        >
      </div>
    {/if}
  {:else}
    <div class="text-area" style="margin-top: 15vh">
      <p style="font-size: 1.5em">練習問題</p>
      <div style="margin-bottom: 4em">
        <p id="text">ボタンを押すと{countDown}秒後にテストが始まります。</p>
        <p>最初は練習問題です。</p>
      </div>
      <button
        id="start-button"
        class="indigo"
        style="width: 50vw; height: 3em; visibility: hidden;"
        on:click={startTest}>スタート</button
      >
      <div style="margin-top: 50px; font-size: 0.9em;">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="20"
          width="20"
          fill="#4d4d4d"
          style="vertical-align: sub;"
          ><path
            d="M10.021 10.458ZM2.354 17.5q-.5 0-.76-.438-.261-.437-.011-.874L9.25 2.979q.25-.437.75-.437t.75.437l7.667 13.209q.25.437-.011.874-.26.438-.76.438Zm7.667-9.146q-.354 0-.615.261-.26.26-.26.614v2.333q0 .355.26.615.261.261.615.261t.614-.261q.261-.26.261-.615V9.229q0-.354-.261-.614-.26-.261-.614-.261Zm0 6.646q.354 0 .614-.26.261-.261.261-.615t-.261-.615q-.26-.26-.614-.26t-.615.26q-.26.261-.26.615t.26.615q.261.26.615.26Zm-6.167.75h12.292L10 5.167Z"
          /></svg
        >
        <span> ブラウザの戻るボタンは使用しないでください。 </span>
      </div>
    </div>
  {/if}
  {#if startFlag && showTest && chapterNum}
    <div style="text-align: end">
      問題{currentTargetIndex +
        1 +
        (isSecondRound
          ? shuffledTargetOrder.length
          : 0)}/{shuffledTargetOrder.length * 2}
    </div>
  {/if}
  <Dialog
    bind:dialog
    text="結果の送信に失敗しました。結果を再送しますか？"
    closeText="終了"
    nextText="再送"
    on:closeDialog={() => dialog.close()}
    on:nextDialog={() => {
      dialog.close()
      postRequest()
    }}
  />
</div>

<style lang="scss">
  svg {
    pointer-events: none;
  }

  #question {
    width: 300px;
    height: 200px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 15vh;
    text-align: center;
    font-size: 4em;
  }

  #countdown {
    font-size: 4em;
  }

  .answer {
    width: 30vw;
    height: 30vw;
    font-size: 4em;
  }

  .text-area {
    text-align: center;
    margin-top: 25vh;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    #question {
      width: 400px;
      height: 180px;
      margin-top: 12vh;
      font-size: 3.5em;
    }

    #countdown {
      font-size: 3.5em;
    }

    .answer-buttons-container {
      margin: 20vh 3em 5vh !important;
      position: relative;
      min-height: 200px;
    }

    .text-area {
      margin-top: 10vh;
    }

    .text-area h4 {
      font-size: 1.3rem;
    }

    .text-area p {
      font-size: 1.2rem;
    }

    .wrapper {
      padding: 0 1rem;
    }
  }

  @media (orientation: landscape) {
    #question {
      width: 350px;
      height: 140px;
      margin-top: 6vh;
      font-size: 2.5em;
    }

    #countdown {
      font-size: 2.5em;
    }

    .answer {
      width: 20vw;
      height: 20vw;
      font-size: 4em;
    }

    .answer-buttons-container {
      margin: 4vh 2em 2vh !important;
      position: relative;
      min-height: 120px;
      justify-content: center;
    }

    .text-area {
      margin-top: 4vh;
    }

    .text-area h4 {
      font-size: 1.1rem;
    }

    .text-area p {
      font-size: 1.1rem;
    }

    .wrapper {
      padding: 0 6vw;
    }
  }
</style>
